export const FETCH_SELECTED_FIELDS = 'FETCH_SELECTED_FIELDS';
export const FETCH_SELECTED_FIELDS_SUCCESS = 'FETCH_SELECTED_FIELDS_SUCCESS';

export const SAVE_SELECTED_FIELDS = 'SAVE_SELECTED_FIELDS';
export const SAVE_SELECTED_FIELDS_SUCCESS = 'SAVE_SELECTED_FIELDS_SUCCESS';

export const FETCH_USER_PREFERENCE = 'FETCH_USER_PREFERENCE';
export const FETCH_USER_PREFERENCE_SUCCESS = 'FETCH_USER_PREFERENCE_SUCCESS';
export const FETCH_USER_PREFERENCE_FAIL = 'FETCH_USER_PREFERENCE_FAIL';

export const SAVE_USER_PREFERENCE = 'SAVE_USER_PREFERENCE';
export const SAVE_USER_PREFERENCE_SUCCESS = 'SAVE_USER_PREFERENCE_SUCCESS';
export const SAVE_USER_PREFERENCE_FAIL = 'SAVE_USER_PREFERENCE_FAIL';
